module.exports = __webpack_public_path__ + "static/media/headerimage.4ad32017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headerimage.png
// module id = 138
// module chunks = 0